// Display text and responsive layout for the user editor; no access rules here.
const GREEK = {
  "Edit User": "Επεξεργασία χρήστη",
  "Profile": "Στοιχεία χρήστη",
  "First Name": "Όνομα",
  "Last Name": "Επώνυμο",
  "Organization": "Οργανισμός",
  "Phone": "Τηλέφωνο",
  "User ID": "Αναγνωριστικό χρήστη",
  "Last release used": "Τελευταία έκδοση που χρησιμοποιήθηκε",
  "Not recorded": "Δεν έχει καταγραφεί",
  "Regular Account Access": "Δικαιώματα λογαριασμού",
  "Empty limits mean unlimited.": "Αφήστε ένα όριο κενό για απεριόριστη χρήση.",
  "Feasibility only": "Μόνο μελέτες σκοπιμότητας",
  "Full access": "Πλήρης πρόσβαση",
  "Feasibility": "Μελέτες σκοπιμότητας",
  "Market Operations": "Λειτουργίες αγοράς",
  "Can submit bids": "Υποβολή προσφορών",
  "Bid submissions": "Υποβολή προσφορών",
  "Wind System": "Αιολικό σύστημα",
  "Market Data": "Δεδομένα αγοράς",
  "Merchant": "Πώληση στην αγορά (Merchant)",
  "PPA": "Συμβάσεις πώλησης (PPA)",
  "Tolling": "Συμβάσεις Tolling",
  "Tolling models": "Συμβάσεις Tolling",
  "Asset Monitoring": "Παρακολούθηση μονάδων",
  "Multiple assets per project": "Πολλαπλές μονάδες ανά έργο",
  "Multiple assets per project (one active at a time)": "Πολλαπλές μονάδες ανά έργο (μία ενεργή κάθε φορά)",
  "Usage limits": "Όρια χρήσης",
  "Market runs / day": "Εκτελέσεις αγοράς / ημέρα",
  "Market runs/day": "Εκτελέσεις αγοράς / ημέρα",
  "Feasibility runs / day": "Εκτελέσεις μελέτης / ημέρα",
  "Feasibility runs/day": "Εκτελέσεις μελέτης / ημέρα",
  "Maximum projects": "Μέγιστος αριθμός έργων",
  "Maximum simulation days": "Μέγιστες ημέρες προσομοίωσης",
  "Last changed": "Τελευταία αλλαγή",
  "by": "από",
  "unknown admin": "άγνωστο διαχειριστή",
  "Recent access changes": "Πρόσφατες αλλαγές δικαιωμάτων",
  "unlimited": "χωρίς όριο",
  "Enabled": "Ενεργό",
  "Disabled": "Ανενεργό",
  "No effective permission change": "Χωρίς αλλαγή δικαιωμάτων",
  "Demo Access": "Δοκιμαστική πρόσβαση",
  "Demo mode enabled": "Ενεργοποίηση δοκιμαστικής πρόσβασης",
  "Market Operations enabled": "Λειτουργίες αγοράς",
  "Wind System enabled": "Αιολικό σύστημα",
  "Market Data enabled": "Δεδομένα αγοράς",
  "Merchant enabled": "Πώληση στην αγορά (Merchant)",
  "PPA enabled": "Συμβάσεις πώλησης (PPA)",
  "Tolling models enabled": "Συμβάσεις Tolling",
  "Demo locked": "Κλειδωμένη δοκιμαστική πρόσβαση",
  "Start Date": "Ημερομηνία έναρξης",
  "Configured Duration": "Διάρκεια (ημέρες)",
  "Duration and daily limits": "Διάρκεια και ημερήσια όρια",
  "Demo expires": "Λήξη δοκιμαστικής πρόσβασης",
  "Configured duration": "Ορισμένη διάρκεια",
  "days": "ημέρες",
  "Remaining days": "Ημέρες που απομένουν",
  "Remaining runs today": "Διαθέσιμες εκτελέσεις σήμερα",
  "Market": "Αγορά",
  "Missing": "Δεν έχει οριστεί",
  "If the backend supports it, the demo start date can be auto-filled on save.": "Η ημερομηνία έναρξης μπορεί να συμπληρωθεί αυτόματα κατά την αποθήκευση, εφόσον υποστηρίζεται από το σύστημα.",
  "Cancel": "Ακύρωση",
  "Save": "Αποθήκευση",
  "Saving...": "Αποθήκευση…",
};

export const userEditorText = (text, isGreek) => isGreek ? (GREEK[text] || text) : text;

export const editorSectionSx = {
  p: { xs: 1.5, sm: 2 }, minWidth: 0,
  border: 1, borderColor: "divider", borderRadius: 2,
  bgcolor: "background.paper",
};

export const editorFieldsSx = {
  display: "grid", gap: 2, minWidth: 0,
  gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" },
  "& > *": { minWidth: 0, width: "100%" },
};

export const editorSwitchesSx = {
  display: "grid", columnGap: 2, rowGap: 0.5, minWidth: 0,
  gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" },
  "& > *": { minWidth: 0, py: 0.75, borderBottom: 1, borderColor: "divider" },
  "& .MuiSwitch-root": { flexShrink: 0 },
  "& .MuiTypography-root": { lineHeight: 1.45, overflowWrap: "anywhere" },
};
